// ======================================================================
// File Name       : EnterpriseNotificationAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { commonCallApi } from '../../utils/ApiUtils';
import * as httpRequests from '../httpRequests/enterpriseNotification';
import * as ActionTypes from '../../constants/actionTypes/enterpriseNotification';
import { RETURN_MAX_NUM } from '../../constants/index';
import * as enterpriseNotification from '../httpRequests/enterpriseNotification';
import * as enterpriseNotificationActionCreators from '../actionCreators/enterpriseNotification/enterpriseNotificationActionCreators';

export function searchEnterpriseNotification(param, displayUserType) {
  return async (dispatch) => {
    const result = await enterpriseNotification.getEnterpriseNotificationList(param, displayUserType);
    if (param.selectTargetData) {
      const link = document.createElement('a');
      if (result && result.csvfileUrl) {
        link.href = result.csvfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      return dispatch(enterpriseNotificationActionCreators.enterpriseNotificationList(result));
    }
  };
}
